<template>
    <div class="panel-body">
        <div class="panel-nav">
            <button class="close-button" v-on:click.prevent="closePanel"></button>
        </div>

        <div class="scroller padded">

        <h2 class="panel-header">Calcola itinerario</h2>

            <loading-progress
                    :indeterminate="loading"
                    :hideBackground="true"
                    shape="line"
                    :size="420"
                    :width="420"
                    height="3"
            />

            <vue-form-generator :schema="schema" :model="route" :options="formOptions"></vue-form-generator>

            <div id="route-details" v-if="showDetails">

                <div class="vue-form-generator">
                    <fieldset>
                    <div class="form-group valid field-submit">
                        <div class="field-wrap">
                            <input type="submit" value="Torna alla mappa" v-on:click.prevent="resetRoute">
                        </div>
                    </div>
                    </fieldset>
                </div>

                <h2>Rifornimenti</h2>

                <ul id="route-stop-list" class="list">
                    <li v-for="(marker, index) in markers"
                        :class="'row-' + ((index % 2) ? 'odd' : 'even')">
                        <p class="description">{{ marker.comune }} - {{ marker.indirizzo }}</p>
                        <p class="price">{{ marker.costo + marker.valuta }}</p>
                    </li>
                </ul>

                <h2>Percorso</h2>

                <ul id="route-list" class="list">
                    <li v-for="(leg, index) in legs"
                        :class="'row-' + ((index % 2) ? 'odd' : 'even')">
                        <span>Da: {{ leg.from }}</span>
                        <span>A: {{ leg.to }}</span>
                        <span class="description">{{ leg.distance }} - {{ leg.duration }}</span>
                    </li>
                </ul>

            </div>
        </div>

    </div>
</template>

<script>

    import { serverBus } from '../main';
    import Api from "../api";
    import VueFormGenerator from "vue-form-generator";

    var async = require("async");

    export default {
        components: {
            "vue-form-generator": VueFormGenerator.component
        },
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            resetRoute() {
                serverBus.$emit('routeCalculated', {
                    polyline: null
                });
                serverBus.$emit("closePanel");
            },
            calcRoute() {
                this.showDetails = false;
                this.waypoints = [];
                this.markers = [];
                this.legs = [];
                this.loading = true;
                this.start_location = null;
                this.end_location = null;

                const $scope = this;

                if(!this.route.from || !this.route.to) {
                    $scope.$swal({
                        title: "Percorso non trovato",
                        text: "Inserisci correttamente l'indirizzo di partenza e di arrivo",
                        icon: "error",
                        button: "Ok",
                    })
                    this.loading = false;
                    return;
                }

                const DirectionsService = new this.gMap.DirectionsService(); //FIXME non è il massimo accederlo così
                DirectionsService.route({
                    origin: this.route.from,
                    destination: this.route.to,
                    travelMode: 'DRIVING'
                }, function(result, status) {
                    if (status == 'OK') {
                        var _route = result.routes[0];
                        var _leg = _route.legs[0];
                        var _lenght = _leg.distance.value;
                        var _stops = [];
                        var _tot = 0;

                        $scope.route.from = _leg.start_address;
                        $scope.route.to = _leg.end_address;
                        $scope.start_location = _leg.start_location;
                        $scope.end_location = _leg.end_location;

                        for (var i = 0; i < _leg.steps.length; i++) {
                            for (var k = 0; k < (_leg.steps[i].path.length - 1); k++) {
                                _tot = _tot + parseFloat($scope.gMap.geometry.spherical.computeDistanceBetween(_leg.steps[i].path[k],_leg.steps[i].path[k+1])/1000);
                                if (_tot > $scope.route.range-$scope.reserve){
                                    _tot = 0;
                                    _stops.push({
                                        lat: _leg.steps[i].path[k+1].lat(),
                                        lng: _leg.steps[i].path[k+1].lng()
                                    });

                                    console.log(_leg.steps[i].path[k+1].lat()+','+_leg.steps[i].path[k+1].lng());
                                }
                            }
                        }

                        if(_stops.length >= 25) {
                            $scope.loading = false;

                            $scope.$swal({
                                title: "Percorso non trovato",
                                text: "Il tragitto selezionato è troppo lungo, prova con delle tratte più brevi.",
                                icon: "error",
                                button: "Ok",
                            })

                            return false;
                        }

                        // check closer distributor to
                        async.eachSeries(_stops,function(_stop,next) {
                            Api.getStations({
                                lat: _stop.lat,
                                lng: _stop.lng
                            }, $scope.$parent.$parent.$parent.$parent.fuel, $scope.reserve, {},true, function (err, res) {
                                if(res.distributori) {
                                    if (res.distributori.length > 0) {
                                        $scope.waypoints.push({
                                            location: [res.distributori[0].latitudine, res.distributori[0].longitudine].join(',')
                                        });

                                        var _dist = res.distributori[0];
                                        $scope.markers.push(_dist);
                                    }
                                    next();
                                } else {
                                    next();
                                }
                            });
                        },function(){
                            DirectionsService.route({
                                origin: $scope.route.from,
                                destination: $scope.route.to,
                                travelMode: 'DRIVING',
                                waypoints: $scope.waypoints
                            }, function(response, status) {
                                var polyline = new $scope.gMap.Polyline({
                                    path: [],
                                    strokeColor: 'rgb(66,166,42)',
                                    strokeWeight: 3
                                });
                                var bounds = new $scope.gMap.LatLngBounds();


                                var legs = response.routes[0].legs;
                                for (var i=0;i<legs.length;i++) {
                                    var steps = legs[i].steps;
                                    for (var j=0;j<steps.length;j++) {
                                        var nextSegment = steps[j].path;
                                        for (var k=0;k<nextSegment.length;k++) {
                                            polyline.getPath().push(nextSegment[k]);
                                            bounds.extend(nextSegment[k]);
                                        }
                                    }

                                    $scope.legs.push({
                                        from: legs[i].start_address,
                                        to: legs[i].end_address,
                                        distance: legs[i].distance.text,
                                        duration: legs[i].duration.text
                                    });
                                }

                                serverBus.$emit('routeCalculated', {
                                    polyline: polyline,
                                    bounds: bounds,
                                    markers: $scope.markers,
                                    start: $scope.start_location,
                                    end: $scope.end_location
                                });

                                $scope.showDetails = true;

                                $scope.loading = false;
                            });
                        });
                    } else {
                        $scope.loading = false;
                        $scope.$swal({
                            title: "Percorso non trovato",
                            text: "Inserisci degli indirizzi più specifici, prova ",
                            icon: "error",
                            button: "Ok",
                        })
                    }
                });
            }
        },
        data() {
            return {
                route: {
                    from: null,
                    to: null,
                    range: 100
                },
                schema: {
                    fields: [{
                        type: "googleAddress",
                        label: "Da",
                        model: "from",
                        placeholder: "Inserisci un indirizzo o un punto di interesse",
                        required: true
                    },{
                        type: "googleAddress",
                        label: "A",
                        model: "to",
                        placeholder: "Inserisci un indirizzo o un punto di interesse",
                        required: true
                    },{
                        type: "select",
                        label: "Range",
                        model: "range",
                        values: function() {
                            return [
                                {id: "100", name: "100km"},
                                {id: "150", name: "150km"},
                                {id: "200", name: "200km"},
                                {id: "250", name: "250km"},
                                {id: "300", name: "300km"},
                                {id: "350", name: "350km"},
                                {id: "400", name: "400km"},
                                {id: "450", name: "450km"},
                                {id: "500", name: "500km"}
                            ]
                        },
                        required: true,
                        selectOptions: {
                            hideNoneSelectedText: true
                        }
                    },{
                        type: "submit",
                        buttonText: "Calcola",
                        onSubmit: this.calcRoute,
                        validateBeforeSubmit: true
                    }]
                },
                formOptions: {
                    validateAfterChanged: true
                },
                showDetails: false,
                reserve: 30,
                gMap: window.google.maps,
                waypoints: [],
                markers: [],
                legs: [],
                start_location: null,
                end_location: null,
                loading: false
            };
        },
        created() {
          serverBus.$emit('pageChanged',{page: 'MapRoute', fuel: this.$parent.$parent.$parent.$parent.fuel});
        }
    }

</script>
